/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, FormsModule } from '@angular/forms';
import { DxDataGridModule } from 'devextreme-angular';
import { DxTemplateModule } from 'devextreme-angular/core';
import { DxoEditingModule, DxoFormModule, DxiItemModule, DxoColumnFixingModule, DxiColumnModule, DxiValidationRuleModule, DxiButtonModule } from 'devextreme-angular/ui/nested';
import { InitStep } from '../../distribution/models/init-step';
import { InitializeService } from '../../distribution/services/initialize.service';
import { DataFieldGroup } from '../../shared/datafields/models';
import { LoadingPanelService } from '../../shared/loading-panel/loading-panel.service';
import { ToastService, ToastType } from '../../shared/toast/toast.service';
import { CurrentUserService } from '../../user/services';
import { ArtifactAssemblyTypes, AssemblyArtifact } from '../models/artifact';
import { FormatType } from '../models/format-type';
import { DeveloperArtifactService } from '../services/developer-artifact.service';
import { DeveloperService } from '../services/developer.service';
import { GridService } from '../../shared/grid/grid.service';
import { SvgIconComponent } from '../../shared/icons/svg-icon.component';
import { PermissionRequiredDirective } from '../../shared/authentication/permission-required.directive';
import { ChangeLogLinkComponent } from '../../shared/change-log/change-log-link/change-log-link.component';
import { ChangeLogLinkEntityDirective } from '../../shared/change-log/change-log-link-entity/change-log-link-entity.directive';
import { BizDataGridDirective } from '../../shared/grid/biz-grid.directive';
import { BizUserColumnDirective } from '../../shared/grid/biz-grid-user.directive';
import { BizDateColumnDirective } from '../../shared/grid/biz-grid-date.directive';
import { DataFieldGroupContainerComponent } from '../../shared/datafields/datafield-group-container.component';
import { DeveloperArtifactAssemblyPickerComponent } from '../developer-artifacts/developer-artifact-assembly-picker.component';
import { BizGridFiltervalues } from 'src/app/shared/grid/biz-grid-filtervalues';
import { ContentType } from 'src/app/distribution/models/content-type';

@Component({
    selector: 'app-developer-format-types',
    templateUrl: './developer-format-types.component.html',
    styleUrls: ['./developer-format-types.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SvgIconComponent, PermissionRequiredDirective, ChangeLogLinkComponent, ChangeLogLinkEntityDirective, DxDataGridModule, BizDataGridDirective, DxoEditingModule, DxoFormModule, DxiItemModule, DxoColumnFixingModule, DxiColumnModule, DxiValidationRuleModule, BizUserColumnDirective, BizDateColumnDirective, DxiButtonModule, DxTemplateModule, FormsModule, DataFieldGroupContainerComponent, DeveloperArtifactAssemblyPickerComponent]
})
export class DeveloperFormatTypesComponent implements OnInit {
    private developerService = inject(DeveloperService);
    private toastService = inject(ToastService);
    private currentUserService = inject(CurrentUserService);
    private initStepService = inject(InitializeService);
    private loadingPanelService = inject(LoadingPanelService);
    private developerArtifactService = inject(DeveloperArtifactService);
    private gridService = inject(GridService);
    public bizGridFiltervalues = inject(BizGridFiltervalues);

    disassembleDisplayGroups: DataFieldGroup[] = [];
    disassembleFormGroup: UntypedFormGroup = new UntypedFormGroup({});
    initStepDisassemblers: InitStep[] = [];
    contentTypes: ContentType[] = [];
    selectedDisassemblerId: number = null;
    formatTypes: FormatType[] = [];
    allowAdding = false;
    allowUpdating = false;
    allowDeleting = false;
    allowShowLog = false;
    probeArtifacts: AssemblyArtifact[];
    isFormatTypeDisassemblerConfigurationOveridden: boolean;

    ngOnInit(): void {
        this.allowAdding = this.currentUserService.hasPermission('Developer_Action_FormatType_Create');
        this.allowUpdating = this.currentUserService.hasPermission('Developer_Action_FormatType_Edit');
        this.allowDeleting = this.currentUserService.hasPermission('Developer_Action_FormatType_Delete');
        this.allowShowLog = this.currentUserService.hasPermission('Developer_Action_ShowLog');
        void this.refresh();
    }

    async refresh() {
        const [formatTypes, initStepDisassemblers, probeArtifacts, contentTypes] = await Promise.all([
            this.developerService.getFormatTypes(),
            this.initStepService.getInitSteps(),
            this.developerArtifactService.getAssemblyArtifacts(true, [ArtifactAssemblyTypes.TypeFormatTypeProbe, ArtifactAssemblyTypes.TypeFormatTypeProbe2]),
            this.developerService.getContentTypes()
        ]);

        this.formatTypes = formatTypes;
        this.initStepDisassemblers = initStepDisassemblers.sort((a, b) => a.Name.localeCompare(b.Name));
        this.contentTypes = contentTypes.sort((a, b) => a.Name.localeCompare(b.Name));
        this.probeArtifacts = probeArtifacts.sort((a, b) => a.Name.localeCompare(b.Name));
    }

    onEditCanceled() {
        this.disassembleDisplayGroups = [];
        this.selectedDisassemblerId = null;
    }

    onRowValidating(e: any) {
        this.disassembleFormGroup.updateValueAndValidity();
        e.isValid = e.isValid && this.disassembleFormGroup.valid;
    }

    async onEditingStart(e: any) {
        const formatType = e.data as FormatType;
        this.disassembleDisplayGroups = [];
        this.selectedDisassemblerId = formatType.DisassemblerInitStepId;
        this.isFormatTypeDisassemblerConfigurationOveridden = await this.developerService.isFormatTypeDisassemblerConfigurationOveridden(formatType.Id);
        await this.setDisassembler(formatType.DisassemblerInitStepId, formatType.Id);

        // Lidt hacky, men for at vi kan få de dynamiske datafield-værdier med i en save, hvor man ikke har ændret andet end disse værdier, så trigger vi en ændring her, så update altid bliver kaldt.
        e.component.cellValue(e.component.getRowIndexByKey(e.key), 'Name', e.component.cellValue(e.component.getRowIndexByKey(e.key), 'Name'));
    }

    onInitNewRow(e: any): void {
        //Clear all fields
        this.disassembleDisplayGroups = [];
        this.selectedDisassemblerId = null;

        //Create New Template
        e.data = { Id: null, Name: null, DefaultExtension: null } as FormatType;
    }

    onRowInserting = (e: any): void => {
        e.cancel = this.gridService.handleDataGridRow(e.data as FormatType, item => this.saveFormatType(item));
    };

    onRowUpdating = (e: any): void => {
        e.cancel = this.gridService.handleDataGridRow({ ...e.key, ...e.newData } as FormatType, item => this.saveFormatType(item as FormatType), e.newData);
    };

    onRowRemoving = (e: any): void => {
        e.cancel = this.gridService.handleDataGridRow(e.data as FormatType, item => this.removeFormatType(item));
    };

    async saveFormatType(formatType: FormatType): Promise<FormatType> {
        const formatTypeExist = this.formatTypes.find(i => i.Name === formatType.Name && i.Id !== formatType.Id || i.ProbeArtifactId === formatType.ProbeArtifactId && i.ProbeArtifactId !== null && i.Id !== formatType.Id);
        if (formatTypeExist) {
            throw new Error('Another format type with that name or probe artifact, already exists.');
        }

        formatType.DisassembleInitStepValues = DataFieldGroup.getDataFieldValues(this.disassembleDisplayGroups, true);
        const newFormatType = await this.developerService.saveFormatType(formatType);

        // Data cleanup
        this.isFormatTypeDisassemblerConfigurationOveridden = false;
        this.toastService.showToast('Format type saved...', ToastType.success);
        return newFormatType;
    }

    async removeFormatType(formatType: FormatType): Promise<FormatType> {
        await this.developerService.deleteFormatType(formatType.Id);
        this.toastService.showToast('Format type deleted...', ToastType.success);
        return formatType;
    }

    async disassemblerChanged(initStepId: number, cellInfo: any) {
        cellInfo.setValue(initStepId);
        await this.setDisassembler(initStepId, cellInfo.data.Id as number);
    }

    async setDisassembler(initStepId: number, formatTypeId?: number) {
        if (initStepId) {
            this.disassembleDisplayGroups = await this.developerService.getFormatTypeDataFieldGroups(initStepId, formatTypeId);
        }
        else {
            this.disassembleDisplayGroups = [];
        }
    }

    setProbeArtifactId(artifactId: string, cellInfo: any) {
        cellInfo.setValue(artifactId || null);
        if (cellInfo.data.ArtifactId !== artifactId && artifactId) { // Only check artifact if it has changed!
            try {
                this.loadingPanelService.showLoadingPanelDirect('Verifying artifact...');
                //const itineraryStepKey = artifactId ? await this.developerService.getItineraryStepKey(artifactId) : null;
                //cellInfo.data.StepKey = itineraryStepKey;
                cellInfo.component.cellValue(cellInfo.row.rowIndex, 'ArtifactId', artifactId);
            } finally {
                this.loadingPanelService.hideLoadingPanel();
            }
        }
    }

    displayExprArtifact = (formatType: FormatType) => {
        if (!formatType.ProbeArtifactId) {
            return '';
        }

        // TODO: Find en bedre måde at håndtere dette, så det ikke er nødvendigt at loade alle artifacts...
        if (this.probeArtifacts) {
            const artifact = this.probeArtifacts.find(a => a.ArtifactId === formatType.ProbeArtifactId);
            if (artifact) {
                return `${artifact.Name} [${artifact.ClassName}] [${artifact.Filename}]`;
            }
        }
        return 'Unknown...';
    };

    displayExprDisassembler = (formatType: FormatType): string =>
        this.initStepDisassemblers.find(x => x.Id === formatType.DisassemblerInitStepId)?.Name;
}
